module.exports = __webpack_public_path__ + "static/media/qualitas.96db9aa9.png";